(function () {
  "use strict";

  var STORAGE_KEY = "fishystuff.domain-color-boot.v1";
  var CACHE_VERSION = 1;
  var MAX_STORED_CHARS = 1_024;
  var DEFAULT_MODE = "theme";
  var MODES = Object.freeze([
    "game",
    "theme-with-game-grades",
    "theme",
  ]);

  function isRecord(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    var prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
  }

  function exactFields(value, expected) {
    var fields = Object.keys(value).sort();
    return fields.length === expected.length
      && fields.every(function (field, index) {
        return field === expected[index];
      });
  }

  function readMode() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw || raw.length > MAX_STORED_CHARS) return null;
      var cache = JSON.parse(raw);
      if (
        !isRecord(cache)
        || !exactFields(cache, ["cacheVersion", "mode", "sourceRevision"])
        || cache.cacheVersion !== CACHE_VERSION
        || !Number.isSafeInteger(cache.sourceRevision)
        || cache.sourceRevision <= 0
        || !MODES.includes(cache.mode)
      ) {
        return null;
      }
      return cache.mode;
    } catch (_error) {
      return null;
    }
  }

  document.documentElement.setAttribute(
    "data-domain-colors",
    readMode() || DEFAULT_MODE,
  );
})();
